export { default } from './index.vue';



// WEBPACK FOOTER //
// ./packages/dof-promt/index.js